/**
 * @copyright © 2022 Universidad Pedagógica Nacional «Francisco Morazán» - UPNFM

 * Dirección de Tecnologías de Información - DTI
 * Departamento de Desarrollo de Sistemas - DSI
 * Laboratorio de Ingeniería Informática «Nébula»

 * -- Delta PU -- Siigei: Sistema informático integrado de gestión institucional

 * @author Marlon López <milopez@upnfm.edu.hn>
*/

// =============================== Importaciones ==============================

import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';

// ================================ Interfaces ================================

// ============================================================================

/**
 * Retorna un componente TextField utilizado para ingresar textos.
 */
export const InputText = ({
	fullWidth = false,
	label,
	maxRows = 5,
	multiline = false,
	name,
	type,
	width = '100%',
	placeholder = '',
}) => {
	// ================================ Variables ===============================

	const { control } = useFormContext();

	// --------------------------------------------------------------------------

	return (
		<Controller
			control={control}
			defaultValue=""
			name={name}
			render={({ field, fieldState: { error } }) => (
				<TextField
					{...field}
					autoComplete="off"
					error={!!error}
					fullWidth={fullWidth}
					helperText={error ? error.message : null}
					label={label}
					maxRows={maxRows}
					multiline={multiline}
					placeholder={placeholder}
					sx={{
						marginTop: 1.5,
						width: { width },
						padding: '0px 5px',
					}}
					type={type}
					variant="outlined"
				/>
			)}
		/>
	);
};
